
/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Matrix } from './bvq';
import { CustomQuestion } from './bvq/custom.question';
import { FileData } from './file';
import { Ibis } from './ibis';
import { SearchableItem, SearchableSelectionType } from './interface';
import { Rma } from './rma';
import { RoT } from './rot';
import { Sic } from './sic';

export class Naics implements SearchableItem {
  CODE: number;
  DESCRIPTION: string;
  NAICS_SICS: Sic[];

  ID: number;
 
  YEAR: number;
  ACTIVE: boolean;
  FILES: FileData[] = [];
  IBIS: any[] = [];
  naics: Naics[] = [];
  NAICS_IBIS: Ibis[] = [];
  ROT: RoT;
  ADDITIONAL_SICS: Sic[] = [];
  PRIMARY_SIC: Sic;
  DATE_UPDATED: Date;
  RMAS: Rma[];

  MATRIX: Matrix = new Matrix();
  CUSTOM: CustomQuestion[] = [];

  // Helpers
  active = false;
  allowed = false;
  IS_COLLAPSE = false;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if (value.NAICS_SICS) {
      this.NAICS_SICS = Sic.parseArray(value.NAICS_SICS);
    }

    if(value.MATRIX){
      this.MATRIX = new Matrix(value.MATRIX);
    }
  }

  static parseArray(json: any[]): Naics[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new Naics(j));
        }
      }
    }

    return arr;
  }
  static parse(json: any): Naics {
    if (json) {
      const f = new Naics();

      f.ID = json.ID;
      f.CODE = json.CODE;
      f.DESCRIPTION = json.DESCRIPTION;
      f.YEAR = json.YEAR;
      f.NAICS_SICS = json.NAICS_SICS ? Sic.parseArray(json.NAICS_SICS) : [];
      f.ACTIVE = json.ACTIVE;
      f.FILES = json.FILES ? FileData.parseArray(json.FILES) : [];
      f.IBIS = json.IBIS;
      f.NAICS_IBIS = json.NAICS_IBIS ? Ibis.parseArray(json.NAICS_IBIS) : [];
      f.naics = json.naics;
      f.ROT = json.ROT ? RoT.parse(json.ROT) : null;
      f.ADDITIONAL_SICS = json.ADDITIONAL_SICS ? Sic.parseArray(json.ADDITIONAL_SICS) : [];
      f.PRIMARY_SIC = json.PRIMARY_SIC ? Sic.parse(json.PRIMARY_SIC) : null;
      f.DATE_UPDATED = json.DATE_UPDATED;
      f.RMAS = json.RMAS ? Rma.parseArray(json.RMAS) : [];

      f.IS_COLLAPSE = f.FILES.length > 0 || f.NAICS_IBIS.length > 0 || f.ROT != null || f.RMAS.length > 0;

      return f;
    } else { return null; }
  }

  getName(): string {
    return this.DESCRIPTION;
  }

  getFullDetails(): string {
    return `${this.CODE} - ${this.DESCRIPTION}`;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
  
}
